import * as React from 'react';
export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 -2 40 40">
      <g fill="none" fillRule="evenodd" stroke="#545759" strokeLinecap="round" strokeWidth="2">
        <path d="M29.799 28.532L10 9M29.799 9L10 28.532" />
      </g>
    </svg>
  );
};
